export const MIN_PRICE = 0;
export const MAX_PRICE = 4000;
export const MIN_DATA = 0;
export const MAX_DATA = 400;
export const MIN_MINUTES = 0;
export const MAX_MINUTES = 1500; //Unlimited
export const MIN_AIRTIME = 0;
export const MAX_AIRTIME = 810; //Unlimited
export const MAX_MONTHLY_RECURRING = 4000;

//CheckoutCreditCheck
export const EMP_CATEGORY_FKEY = "employmentType";
export const EMP_CATEGORY_LKEY = "employmentCode";
export const OCCUPATION_TYPE_FKEY = "occupationType";
export const OCCUPATION_TYPE_LKEY = "occupationCode";
export const OCCUPATIONS_FKEY = "description";
export const OCCUPATIONS_LKEY = "id";
export const SALARY_DAY_FKEY = "name";
export const SALARY_DAY_LKEY = "value";
export const ACCOUNT_TYPE_FKEY = "name";
export const ACCOUNT_TYPE_LKEY = "value";
export const ACCOUNT_TYPE = "accountType";
export const DEBIT_DATE_FKEY = "name";
export const DEBIT_DATE_LKEY = "value";
export const BANK_NAME = "bankName";
export const MALE = "Male";
export const FEMALE = "Female";
export const MR = "Mr";
export const MRS = "Mrs";
export const MISS = "Miss";
export const UNIT = "unit";
export const BUSINESS = "building";
export const STREET_NO = "street_number";
export const ROUTE = "route";
export const SUBURB = "suburb";
export const MINOR_SUBURB = "minor_region";
export const PROVINCE = "province";
export const POST_STREET = "post_street";
export const POST_BOX = "post_box";
export const TOWN = "town";
export const CITY = "city";
export const SID = "SID";
export const SPP = "SPP";
export const FPP = "FPP";
export const SA_COUNTRY = "SOUTH AFRICA-ZA";
export const STREET_ADDR = "Street Address";
export const BUILDING_ADDR = "Building Address";
export const CONSENT_CHECK = "consentCheck0";
export const AGREE_CHECK = "consentCheck1";
export const P50_CUST = "P0050";

export const MAX_ONCE_OF = 50000;
export const UNLIMITED = 100000;
export const MOBILE_WIDTH = 576;
export const TABLET_WIDTH = 992;
export const TABLET_WIDE_WIDTH = 1024;
export const USE_DRUPAL_DATA = true;

export const FILTER_HEADERS = {
  FILTER_DEALS: "Filter deals",
  FILTERS: "Filters",
  PLAN_TYPE: "I’m looking for...",
  BUDGET: "Budget",
  CONTRACT_TYPE: "Contract options",
  DATA_VOICE: "Data & voice minutes",
  MORE_FILTERS: "More filters",
  SORT_BY: "Sort by",
  RESET_ALL: "Reset all",
  PROMOTIONS: "Promotions",
  ACCESSORIES_AND_VOUCHERS: "Accessories & vouchers",
  RESET: "Reset",
};
export const BACK_ORDER_DEAL_AVAILABILITY_STATUS = 411;

export const CHECKOUT_CONFIG = {
  normalStepsTracker: [
    {
      stepNo: 1,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 2,
      title: "Review order",
      heading: "Review order",
      id: "review",
    },
    {
      stepNo: 3,
      title: "Payment",
      heading: "Payment",
      id: "payment",
    },
    {
      stepNo: 4,
      title: "Order confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  newLineStepsTracker: [
    {
      stepNo: 1,
      title: "Authentication",
      heading: "Authentication",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Credit check",
      heading: "Credit check",
      id: "creditCheck",
    },
    {
      stepNo: 3,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 4,
      title: "Review & submit",
      heading: "Review & submit",
      id: "review",
    },
    {
      stepNo: 5,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  newLineStepsTrackerWithPayment: [
    {
      stepNo: 1,
      title: "Authentication",
      heading: "Authentication",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Credit check",
      heading: "Credit check",
      id: "creditCheck",
    },
    {
      stepNo: 3,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 4,
      title: "Review order",
      heading: "Review order",
      id: "review",
    },
    {
      stepNo: 5,
      title: "Submit & pay",
      heading: "Submit & pay",
      id: "payment",
    },
    {
      stepNo: 6,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  newLineStepsTrackerWithNumberTransfer: [
    {
      stepNo: 1,
      title: "Authentication",
      heading: "Authentication",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Credit check",
      heading: "Credit check",
      id: "creditCheck",
    },
    {
      stepNo: 3,
      title: "Number transfer",
      heading: "Number transfer",
      id: "numberTransfer",
    },
    {
      stepNo: 4,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 5,
      title: "Review & submit",
      heading: "Review & submit",
      id: "review",
    },
    {
      stepNo: 6,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  newLineStepsTrackerWithNumberTransferPayment: [
    {
      stepNo: 1,
      title: "Authentication",
      heading: "Authentication",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Credit check",
      heading: "Credit check",
      id: "creditCheck",
    },
    {
      stepNo: 3,
      title: "Number transfer",
      heading: "Number transfer",
      id: "numberTransfer",
    },
    {
      stepNo: 4,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 5,
      title: "Review order",
      heading: "Review order",
      id: "review",
    },
    {
      stepNo: 6,
      title: "Submit & pay",
      heading: "Submit & pay",
      id: "payment",
    },
    {
      stepNo: 7,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  upgradeStepsTracker: [
    {
      stepNo: 1,
      title: "Authorisation",
      heading: "Authorisation",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 3,
      title: "Review & submit",
      heading: "Review & submit",
      id: "review",
    },
    {
      stepNo: 4,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  upgradeStepsTrackerWithPayment: [
    {
      stepNo: 1,
      title: "Authorisation",
      heading: "Authorisation",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 3,
      title: "Review order",
      heading: "Review order",
      id: "review",
    },
    {
      stepNo: 4,
      title: "Submit & pay",
      heading: "Submit & pay",
      id: "payment",
    },
    {
      stepNo: 5,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  upgradeStepsTrackerWithNumberTransfer: [
    {
      stepNo: 1,
      title: "Authorisation",
      heading: "Authorisation",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Number transfer",
      heading: "Number transfer",
      id: "numberTransfer",
    },
    {
      stepNo: 3,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 4,
      title: "Review & submit",
      heading: "Review & submit",
      id: "review",
    },
    {
      stepNo: 5,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],
  upgradeStepsTrackerWithNumberTransferPayment: [
    {
      stepNo: 1,
      title: "Authorisation",
      heading: "Authorisation",
      id: "authentication",
    },
    {
      stepNo: 2,
      title: "Number transfer",
      heading: "Number transfer",
      id: "numberTransfer",
    },
    {
      stepNo: 3,
      title: "Delivery",
      heading: "Delivery details",
      id: "delivery",
    },
    {
      stepNo: 4,
      title: "Review order",
      heading: "Review order",
      id: "review",
    },
    {
      stepNo: 5,
      title: "Submit & pay",
      heading: "Submit & pay",
      id: "payment",
    },
    {
      stepNo: 6,
      title: "Confirmation",
      heading: "Confirmation",
      id: "orderConfirmation",
    },
  ],

  normalJourney: {
    delivery: { prevStep: "login", activeStepNo: 1 },
    review: { prevStep: "delivery", activeStepNo: 2 },
    payment: { prevStep: "review", activeStepNo: 3 },
    orderConfirmation: { prevStep: "delivery", activeStepNo: 4 },
  },
  newLineJourney: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    xds: { prevStep: "authentication", activeStepNo: 1 },
    creditCheck: { prevStep: "authentication", activeStepNo: 2 },
    delivery: { prevStep: "creditCheck", activeStepNo: 3 },
    review: { prevStep: "delivery", activeStepNo: 4 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 5 },
  },
  newLineJourneyWithPayment: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    xds: { prevStep: "authentication", activeStepNo: 1 },
    creditCheck: { prevStep: "authentication", activeStepNo: 2 },
    delivery: { prevStep: "creditCheck", activeStepNo: 3 },
    review: { prevStep: "delivery", activeStepNo: 4 },
    payment: { prevStep: "review", activeStepNo: 5 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 6 },
  },
  newLineJourneyWithNumberTransfer: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    xds: { prevStep: "authentication", activeStepNo: 1 },
    creditCheck: { prevStep: "authentication", activeStepNo: 2 },
    numberTransfer: { prevStep: "creditCheck", activeStepNo: 3 },
    delivery: { prevStep: "numberTransfer", activeStepNo: 4 },
    review: { prevStep: "delivery", activeStepNo: 5 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 6 },
  },
  newLineJourneyWithNumberTransferPayment: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    xds: { prevStep: "authentication", activeStepNo: 1 },
    creditCheck: { prevStep: "authentication", activeStepNo: 2 },
    numberTransfer: { prevStep: "creditCheck", activeStepNo: 3 },
    delivery: { prevStep: "numberTransfer", activeStepNo: 4 },
    review: { prevStep: "delivery", activeStepNo: 5 },
    payment: { prevStep: "review", activeStepNo: 6 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 7 },
  },
  upgradeJourney: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    delivery: { prevStep: "authentication", activeStepNo: 2 },
    review: { prevStep: "delivery", activeStepNo: 3 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 4 },
  },
  upgradeJourneyWithPayment: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    delivery: { prevStep: "authentication", activeStepNo: 2 },
    review: { prevStep: "delivery", activeStepNo: 3 },
    payment: { prevStep: "review", activeStepNo: 4 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 5 },
  },
  upgradeJourneyWithNumberTransfer: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    numberTransfer: { prevStep: "authentication", activeStepNo: 2 },
    delivery: { prevStep: "numberTransfer", activeStepNo: 3 },
    review: { prevStep: "delivery", activeStepNo: 4 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 5 },
  },
  upgradeJourneyWithNumberTransferPayment: {
    authentication: { prevStep: "login", activeStepNo: 1 },
    otp: { prevStep: "authentication", activeStepNo: 1 },
    numberTransfer: { prevStep: "authentication", activeStepNo: 2 },
    delivery: { prevStep: "numberTransfer", activeStepNo: 3 },
    review: { prevStep: "delivery", activeStepNo: 4 },
    payment: { prevStep: "review", activeStepNo: 5 },
    orderConfirmation: { prevStep: "authentication", activeStepNo: 6 },
  },
};

export const NumberTransferTypes = Object.freeze({
  NEW_NUMBER: "new number",
  VOD_NUMBER: "vodacom number",
  EXTERNAL: "another network",
});

export const CREDIT_VETTING_STATUS = {
  approved: "APPROVED",
  pending: "PENDING",
  referred: "REFERRED",
  offline: "OFFLINE",
  approvedWithConditions: "APPROVED WITH CONDITIONS",
};

export const LEAD_BUCKETS = {
  general: "General_help",
  default: "leads_new",
  startCheckout: "Start_checkout",
  delivery: "Delivery_details",
  orderReview: "Order_review",
  orderConfirmation: "Order_confirmation",
  payment: "Payment_details",
  addLine: {
    xds: "XDS_authentication",
    otpAuth: "verification_of_existing_customer_addon_line_otp",
    creditVetting: "credit_vetting",
    numberTransfer: "number_transfer",
  },
  upgrade: {
    otpAuth: "upgrade_authorisation",
  },
};

export const VODAPAY_RESULT_CODES = {
  success: "9000",
  processing: "8000",
  failed: "4000",
  cancelled: "6001",
};

export const ScreenSizeTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop'
};

// Deal Details
export const COLOR_LABEL = "Colour";
export const SmartphonesLabel = 'Smartphones';
export const DoubleDealItems = [
  'CioT Devices',
  'Feature Phones',
  'Fibre',
  'Gaming',
  'Laptop',
  'Modems',
  'Portable Audio',
  'Printers',
  'Scanners',
  'Smartphones',
  'Tablet',
  'Wearable Tech'
];

export const DeviceTypes = {
  PrimaryDevice: "primary",
  SecondaryDevice: 'secondary',
  Inclusion: 'inclusion',
};

export const NotificationTypes = {
  Warning: "warning",
  Error: "error",
  Success: "success"
}

export const StockStatus = {
  IN_STOCK: 'IN_STOCK', 
  OUT_OF_STOCK: "OUT_OF_STOCK",
};

export const StockMode = {
  IN_STOCK: 'IN_STOCK', 
  OUT_OF_STOCK: "OUT_OF_STOCK",
  BACK_ORDER: "BACK_ORDER"
};

export const StockNotifications = {
  BackOrder: {
    text: "Delayed delivery",
    description: "The colour you have chosen is currently unavailable. Please be advised that if you select this colour, your delivery may be delayed by 2-3 weeks.",
    type: NotificationTypes.Warning,
  },
  OutOfStock: {
    text: "Colour out of stock",
    description: "",
    type: NotificationTypes.Error,
  }
};
